import React from 'react';
import { useAPIContext } from '../../context/api';
import { BrandsAPI } from '../../../../constructs/brands/interface';
import { ChatMessage } from '../../../../types/brands';

export const useChatMessages = (bannerId: string) => {
  const { callEndpoint } = useAPIContext();
  const [messages, setMessages] = React.useState<ChatMessage[]>([]);
  const [initialLoading, setInitialLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const [isInitialized, setIsInitialized] = React.useState(false);

  const fetchMessages = React.useCallback(async () => {
    if (!bannerId) return;

    try {
      if (!isInitialized) {
        setInitialLoading(true); // Solo en primera carga
      }
      setError(null);

      const response = await callEndpoint<BrandsAPI, 'get-chat-messages'>(
        'brands',
        `/banners/${bannerId}/messages`,
        'GET'
      );

      if (response) {
        setMessages(response.messages);
        setIsInitialized(true);
      }
    } catch (err) {
      console.error('Error fetching chat messages:', err);
      setError('Error al cargar los mensajes');
    } finally {
      setInitialLoading(false);
    }
  }, [bannerId, callEndpoint, isInitialized]);

  // Fetch inicial
  React.useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  return {
    messages,
    loading: initialLoading,
    error,
    refetch: fetchMessages
  };
};
